var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15511_12854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16661 3.94518C6.18576 4.35162 3.88883 6.90754 3.88883 9.99995C3.88883 13.375 6.62487 16.1111 9.99995 16.1111C13.375 16.1111 16.1111 13.375 16.1111 9.99995C16.1111 9.53971 16.4842 9.16661 16.9444 9.16661C17.4046 9.16661 17.7777 9.53971 17.7777 9.99995C17.7777 14.2955 14.2955 17.7777 9.99995 17.7777C5.7044 17.7777 2.22217 14.2955 2.22217 9.99995C2.22217 5.7044 5.7044 2.22217 9.99995 2.22217C10.4602 2.22217 10.8333 2.59526 10.8333 3.0555V8.55625C11.3314 8.84442 11.6666 9.38304 11.6666 9.99995C11.6666 10.9204 10.9204 11.6666 9.99995 11.6666C9.07947 11.6666 8.33328 10.9204 8.33328 9.99995C8.33328 9.38304 8.66844 8.84442 9.16661 8.55625V7.05941C7.88411 7.42215 6.94439 8.6013 6.94439 9.99995C6.94439 11.6875 8.31241 13.0555 9.99995 13.0555C11.6875 13.0555 13.0555 11.6875 13.0555 9.99995C13.0555 9.53971 13.4286 9.16661 13.8888 9.16661C14.3491 9.16661 14.7222 9.53971 14.7222 9.99995C14.7222 12.608 12.608 14.7222 9.99995 14.7222C7.39193 14.7222 5.27772 12.608 5.27772 9.99995C5.27772 7.67628 6.95605 5.74461 9.16661 5.35102V3.94518Z",
    fill: "#71869D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15511_12854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatus);
export default __webpack_public_path__ + "static/media/iconStatus.93943f22a6eefdff0788fa19ad3d9167.svg";
export { ForwardRef as ReactComponent };